export const fUsd = (v: number | null | undefined) =>
  v == null || !Number.isFinite(v) ? '—' : '$' + v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const fEth = (v: number | null | undefined, d = 5) =>
  v == null || !Number.isFinite(v) ? '—' : v.toFixed(d)

/** Signed basis points, rounded. Uses a true minus sign, not a hyphen. */
export function fBps(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return '—'
  const r = Math.round(v)
  return (r > 0 ? '+' : r < 0 ? '−' : '') + Math.abs(r) + ' bps'
}

export function bpsGlyph(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return ''
  return Math.round(v) > 0 ? '▲' : Math.round(v) < 0 ? '▼' : '='
}

/** Coarse age. Never seconds — the reference is a print, not a stream. */
export function fAge(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms)) return '—'
  const m = Math.max(0, Math.round(ms / 60000))
  if (m < 60) return `${m}m`
  const h = Math.floor(m / 60)
  if (h < 48) return `${h}h ${m % 60}m`
  return `${Math.floor(h / 24)}d ${h % 24}h`
}

const et = (d: Date, opts: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', ...opts }).format(d)

export const fET = (d: Date | string) =>
  et(new Date(d), { hour: '2-digit', minute: '2-digit', hour12: false }) + ' ET'

export const fUTC = (d: Date | string) =>
  new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(d)) + ' UTC'

export const fDateET = (d: Date | string) =>
  et(new Date(d), { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false })

export const short = (a: string, head = 6, tail = 4) =>
  !a ? '' : a.length <= head + tail + 1 ? a : `${a.slice(0, head)}…${a.slice(-tail)}`
